import {
  ModalKey,
  ModalSlice,
  ModalsMap,
  MODAL_MISSING_DIGITAL_PAYMENT_INFO_FALLBACK_KEY,
} from './modal-types'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

const modalsMap: ModalsMap = {
  [MODAL_MISSING_DIGITAL_PAYMENT_INFO_FALLBACK_KEY]: {
    key: MODAL_MISSING_DIGITAL_PAYMENT_INFO_FALLBACK_KEY,
    label: "You're almost done",
  },
}

const modalSlice = createSlice({
  name: 'modal',
  initialState: null as ModalSlice,
  reducers: {
    open: (_, action: PayloadAction<ModalKey>) => {
      return modalsMap[action.payload]
    },
    close: () => {
      return null
    },
  },
})

export default modalSlice
